/**
 * @generated SignedSource<<98cff4a06cbfa03d6cd484866a6dd8bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VideoElementDisplay_VideoLearnElementFragment$data = {
  readonly subtitles: ReadonlyArray<{
    readonly subtitles: ReadonlyArray<{
      readonly endTimeInSec: any;
      readonly startTimeInSec: any;
      readonly text: string;
    }>;
  }>;
  readonly title: string;
  readonly videoFile: {
    readonly url: string | null;
  } | null;
  readonly " $fragmentType": "VideoElementDisplay_VideoLearnElementFragment";
};
export type VideoElementDisplay_VideoLearnElementFragment$key = {
  readonly " $data"?: VideoElementDisplay_VideoLearnElementFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"VideoElementDisplay_VideoLearnElementFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VideoElementDisplay_VideoLearnElementFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "videoFile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SubtitlesForLanguage",
      "kind": "LinkedField",
      "name": "subtitles",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "VideoSubtitle",
          "kind": "LinkedField",
          "name": "subtitles",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startTimeInSec",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endTimeInSec",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "text",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "VideoLearnElement",
  "abstractKey": null
};

(node as any).hash = "569ebc2d3f2c66c4cb645fb096546f85";

export default node;
